import HeroSection from "../../../components/hero-section/HeroSection";
import bgImg from "../../../resources/images/hfi-images/Svit-Video-Production-2.webp";
import TermCondition from "../../../components/footer/term-conditions/termCondition";

const TermConditionPage = () => {
  return (
    <div>
      <HeroSection
        title={""}
        subtitle={"Term Condition"}
        backgroundImage={bgImg}
      />

      <TermCondition />
    </div>
  );
};

export default TermConditionPage;
